import OrderDataLoad from './OrderDataLoad'

export default OrderDataLoad
